import React, { useState, useEffect, useRef, useContext } from "react";
import { Link } from 'react-router-dom';
import axios from "axios";
import Costanti from '../../constantiX';
import { Dropdown,DataView, DataTable,Column, TabView,TabPanel, Button, Dialog,Fieldset,Panel, RadioButton  } from "primereact";

import { Carousel } from 'react-responsive-carousel';
import Moment from 'moment';
import ReactGA from "react-ga4";
import {FormattedMessage  } from 'react-intl';

import "react-responsive-carousel/lib/styles/carousel.min.css";

class Scheda extends React.Component {
   
    constructor() {
        super();
        this.state = { conta:0,xcarica:'sezione', InfoMessage:{valore1:'',valore2:''}, tipoVisual:0 , width: 0, height: 0, dati:{}, visible3: false, deco1:'', deco2:''};
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.myRef1 = React.createRef();
        this.myRef2 = React.createRef();
        this.myRef3 = React.createRef();
        this.myRef4 = React.createRef();
        this.myRef5 = React.createRef();
        this.myRef6 = React.createRef();
     
      }
    
  
      updateWindowDimensions() {
        var tipow=3;
        if(window.innerWidth>=0 && window.innerWidth<=767)tipow=1;
        if(window.innerWidth>=768 && window.innerWidth<1024)tipow=2;
         this.setState({ tipoVisual : tipow, width: window.innerWidth, height: window.innerHeight });
      }

      componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
      }
      

    showMessage(messageError,tipo) {
        var icona='';
        if(tipo=='error'){
          icona='pi pi-times-circle';
        }
        if(tipo=='info'){
          icona='pi pi-info-circle';
        }
        if(tipo=='success'){
          icona='pi pi-check-circle';
        }
        if(tipo=='warning'){
          icona='pi pi-exclamation-triangle';
        }
        this.toastBC.show({ severity: tipo,  life: 3000, closable: false, content: (
            <div className="flex flex-column" style={{flex: '1'}}>
                <div className="text-center">
                 <i className={icona} style={{fontSize: '3rem'}}></i>
                    <h4>{messageError}</h4>
                </div>
            </div>
        ) });
      }



      componentDidMount() {
      
   
        //Usage
    
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        var id=this.props.match.params.id;
   
        let config = {
            headers: {
              'Authorization': 'Bearer ' + this.token
            }
          }
         this.setState({loading:true,id:id,deco1:'Data Lotto',deco2:'Data Scadenza'});
         sessionStorage.removeItem("DecoLotto1");
         sessionStorage.removeItem("DecoLotto2");
         sessionStorage.removeItem("DecoStabilimento");
         sessionStorage.removeItem("infolotto");
     
       
         sessionStorage.setItem("DecoLotto1","Data Lotto");
         sessionStorage.setItem("DecoLotto2","Data Scadenza");
         sessionStorage.setItem("DecoStabilimento","Stabilimento");
        
    
         var quer=id;
         var dettaglio='';
              axios.get(Costanti.UrlCallApi+"scheda/"+quer,config)
                .then(res => {

                    res.data.lista8.forEach(element => {
                      axios.get(Costanti.UrlCallApi+"file/get/"+res.data.lista2[0].id+'/processo/'+element.id);

                    }
                    );
                    res.data.lista9.forEach(element => {
                      axios.get(Costanti.UrlCallApi+"file/get/"+res.data.lista2[0].id+'/produzione/'+element.id);
                    }
                    );

                    this.setState({dati:res.data,loading:false,editMode:false,indexLotto:-1});
                     dettaglio=res.data.lista2[0].ragionesociale+'->'+res.data.lista1[0].descrizione+'['+res.data.lista1[0].codiceprodotto+']';
                     ReactGA.send({ hitType: "pageview", page:this.props.location.pathname});
                     ReactGA.event({
                         category: 'Accesso QRCode',
                         action: 'Accesso QRCode',
                         label: dettaglio
             
                       });
                  
                       axios.get(Costanti.UrlCallApi+"decodifica/all?aziendaid="+res.data.lista2[0].id+"&tipo=2",config)
                       .then(res => {
                        this.setState({InfoMessage:res.data.conta1>0?res.data.lista1[0]:{},InfoCount:res.data.conta1})
          

                       })

                       

                       axios.get(Costanti.UrlCallApi+"decodifica/all?aziendaid="+res.data.lista2[0].id+"&tipo=1",config)
                       .then(res => {
                          res.data.lista1.forEach(element => {
                            if(element.nome==='infolotto'){  
                              localStorage.setItem("infolotto","S");
                              }
                             if(element.nome==='stabilimento'){  
                            sessionStorage.setItem("DecoStabilimento",element.valore1);
                            }
                            if(element.nome==='DecoLotto1')  {
                              sessionStorage.setItem("DecoLotto1",element.valore1);
                              this.setState({deco1:element.valore1})
                            }
                            if(element.nome==='DecoLotto1EN')  {
                              sessionStorage.setItem("DecoLotto1EN",element.valore1);
                              this.setState({deco1EN:element.valore1})
                            }
                          
                            if(element.nome==='DecoLotto2'){  
                              sessionStorage.setItem("DecoLotto2",element.valore1);
                              this.setState({deco2:element.valore1})
                            }
                            if(element.nome==='DecoLotto2EN'){  
                              sessionStorage.setItem("DecoLotto2EN",element.valore1);
                              this.setState({deco2EN:element.valore1})
                            }
                           });
                     
                       }).catch(error=> {
                           //alert(JSON.stringify(error))
                            this.showMessage('error','Errore carico decodiche',error.message);
                       });
                   
               }).catch(error=> {
             alert(error)
        });
      
        
     }

    
     responsiveOptions = [
      {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 3
    },
    {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 2
    },
    {
        breakpoint: '560px',
        numVisible: 1,
        numScroll: 1
    }
  ];

 legendTemplate =(x)=>{
  return (<div></div> )
 }
  productTemplate = (product) => {
   
    return (
      
      <div className="cardc1 mx-3 mb-3 p-3 border-1 border-50 border-round h-full md:h-full lg:h-full">
      
      <div className="mb-3 align-items-center justify-content-center  w-full">
                 <span className="bg-blue-500 text-0 flex align-items-center justify-content-center border-circle" style={{ maxWidth: '2.5rem', maxHeight: '2.5rem' }}>
                       {this.state.dati.lista9.indexOf(product)+1}
                  </span>

                    <img className="mb-3 align-items-center justify-content-center  w-full" src={Costanti.UrlCallApi+'file/get/'+product.aziendaid+'/produzione/'+product.id+'?'+Math.random()} alt="" style={{ maxWidth:'150pt', objectFit: 'contain', maxHeight:'150pt' }}/>
                </div>
                <div className="justify-content-right  cardc2 font-medium">
                  {product.descProcesso}
                </div>
                <div className="justify-content-right text-900 font-medium">
                  {product.descrizione}
              </div>
              <div className="flex justify-content-between text-1000">
                    <span className="inline-flex">
                       <i className="pi pi-calendar mr-2"></i><span className="font-small">{Moment(new Date(product.dataupd)).format("DD/MM/yyyy")}</span>
                    </span>
              </div>
        </div>
    );
}




itemTemplate(data, layout) {
  if (!data) {
      return;
  }


  
  return (

   <div className="card w-full">
       
      <div className="col-4 md:col-4 lg:col-4 box">
        Hash:      {data.hash}
       </div>
       <div className="col-4 md:col-4 lg:col-4 box">
       Data: {Moment(new Date(data.datains)).format("DD/MM/yyyy HH:mm:ss")}
       </div>
       <div className="col-4 md:col-4 lg:col-4 box">
                         <Button className="p-button-raised p-button-danger" tooltip="Scarica PDF" >
               <a href={Costanti.UrlCallApi+'file/getHash/'+data.hash} target="_blank">
                  <i className="pi pi-file-pdf mr-2 text-white"></i>
            </a>
            </Button>
            
            <Button className="p-button-raised p-button-info" tooltip={this.lingua()=='IT'?"Visualizza Transazione":"View Transaction"}  >
            <a href={'https://algoexplorer.io/tx/'+data.transazione} target="_blank">
                  <i className="pi pi-file mr-2 text-white"></i>
            </a>
            </Button>
      </div>
    </div>
  ) 
}
split4(sentence){
//  alert(JSON.stringify(this.lingua()));
    var rit=sentence.substring(0,8)+"...";
    return rit;

}

lunghezza(sentence){
  return JSON.stringify(sentence).length;
}

splitta1(sentence,num){
 // alert(JSON.stringify(sentence));
      var rit=sentence.substring(0,num)+"...";
      return rit;
  }
  splitta2(sentence,num){
    //  alert(JSON.stringify(this.lingua()));
        var rit="..."+sentence.substring(num);
        return rit;
    }
  
  
cerca(val){

var id=0;  
this.state.dati.lista3.forEach((element,index) => {
  if(element.id==val){  
      id=index
   }
  });
  this.setState({indexLotto:id});
  this.setState({selected:val});
  this.caricaCertificazioni(val);
}

caricaCertificazioni(lottoid){
  let config = {
      headers: {
        'Authorization': 'Bearer ' + this.token
      }
    }
    this.setState({loading:true});
  var quer='page=1&num=10000&aziendaid='+this.state.dati.lista1[0].aziendaid+'&idcollegato='+this.state.dati.lista1[0].id+'&lottoid='+lottoid+'&tipo=2';
  axios.get(Costanti.UrlCallApi+"certificazione/all?"+quer,config)
  .then(res => {
      let app=this.state.dati;
      if(res.data.conta1>0){
        app.lista4=res.data.lista1;
        app.conta4=res.data.conta1;
      }
      var quer='page=1&num=10000&aziendaid='+this.state.dati.lista1[0].aziendaid+'&idcollegato='+this.state.dati.lista1[0].id+'&lottoid=0&tipo=2';
      axios.get(Costanti.UrlCallApi+"certificazione/all?"+quer,config)
      .then(res1 => {
       
        if(res1.data.conta1>0){
          app.lista4.push(res1.data.lista1);
          app.conta4+=res1.data.conta1;
        }
        let app2=[];

        app.forEach((element,index) =>{
            if(element.id>0){
              app2.add(element);
            }
        });
        this.setState({dati:app2,loading:false})
      });

     
      
      //alert(JSON.stringify(this.state.prodotti))
     }).catch(error=> {
       alert(error)
  });
} 


setVisible1(value){
  this.setState({visible1:value})
}
setVisible3(value){
  this.setState({visible3:value})
}

setInfo(value){
  this.setState({info:value})
}


esiste(azid,tipo,id) {
  var ris="";
  let config = {
    headers: {
      'Authorization': 'Bearer ' + this.token
    }
  }


  this.setState({loading:true});


   
  axios.get(Costanti.UrlCallApi+'file/esiste/'+azid+'/'+tipo+'/'+id,config)
  .then(res => {
    alert(res.data)  
    this.setState({loading:false});
  }).catch(error=> {
      //alert(JSON.stringify(error))
     
       this.setState({loading:false});

  });
}

lingua(){
  var a="";
  if(document.getElementById("aaGG"))
  a=document.getElementById("aaGG").innerText;
  if(a==="") a=(navigator.language=== 'it-IT'?"IT":"UK");
  return a;
}

render() {

  
  return( 
  <div>
  

  <Dialog visible={this.state.visible1} closable={false} modal 
      style={{ width: '90%', height:'100%' }} header={this.lingua()=='IT'?"Mappa":"Maps"} draggable={false} resizable={false}
   footer={<div className="border-top-1 surface-border pt-3">
            <Button icon="pi pi-check" onClick={() => this.setVisible1(false)} label="Chiudi" />
            </div>}>
            <div className="flex flex-wrap border-top-1 surface-border pt-4">
                <iframe style={{width:'100vw',height:'60vh'}}   id="gmap_canvas" 
                src={'https://maps.google.com/maps?q='+this.mappa+'&t=&z=13&ie=UTF8&iwloc=&output=embed'} 
                frameborder="0" marginheight="0" marginwidth="0"></iframe>
            </div>
        </Dialog>


        <Dialog visible={this.state.info} closable={false} modal 
           style={{ width: '40%', height:'40%' }} header={this.lingua()=='IT'?"Informazione":"Information"} draggable={false} resizable={false}
           footer={<div className="border-top-1 surface-border pt-3">
            <Button icon="pi pi-check" onClick={() => this.setInfo(false)} label="Chiudi" />
            </div>}>
            {this.lingua()=='IT'?  
            <div className="flex flex-wrap border-top-1 surface-border pt-4">
             {this.state.InfoMessage.valore1?this.state.InfoMessage.valore1:''} 
          
            </div>: <div className="flex flex-wrap border-top-1 surface-border pt-4">
            {this.state.InfoMessage.valore2?this.state.InfoMessage.valore2:''} 
         
              </div>
          }
        </Dialog>
    <div className="mx-2">

      
    <div className="grid grid-nogutter">

    {this.state.tipoVisual==1?
     <div>
        <div class="grid p-3">
        <div className="font-bold text-900 text-4xl mb-3">
      {(this.state.dati.lista1?
        (this.lingua()=='IT'
        ?this.state.dati.lista1[0].nome:this.state.dati.lista1[0].nomeen)
  
      :"")}
      </div>
      <div className="align-items-center justify-content-center">
        {(this.state.dati.lista1?<img src={Costanti.UrlCallApi+'file/get/'+this.state.dati.lista1[0].aziendaid+'/prodotto/'+this.state.id+'?'+Math.random()}
         style={{maxWidth:'100%', objectFit: 'contain'}}  />:"")}
      </div>
      
         <div className="mt-3 mb-3">
          {(this.state.dati.lista1?
          (this.lingua()=='IT'?this.state.dati.lista1[0].descrizione:this.state.dati.lista1[0].descrizioneen)
            :"")}
         </div>
      

         {(this.state.dati.conta3>0?
             <div className="grid cardc mx-1 border-round ">
             <div className="col-12 font-bold text-900 text-3xl mx-2 ">
             <FormattedMessage id ="prodotto.lotti" />
             {localStorage.getItem("infolotto")=="S"?
             <label onClick={()=>this.setInfo(true)} style={{cursor:'pointer'}}><i className="pi pi-info-circle mx-2"></i>
                   </label>:<label  />
              }
             <div className="col-12 font-bold text-900 mt-3 ">
             <FormattedMessage id="prodotto.sellotto" defaultMessage="search">
              {placeholder=>  
                 <Dropdown id="cercaLotto" options={this.state.dati.lista3} 
                  value={this.state.selected}
                  onChange={(e)=>this.cerca(e.value)} className="w-full"
                     optionLabel="numero" optionValue="id" placeholder={placeholder}/>   
                  }
              </FormattedMessage>  
              </div>
              </div>
              
               <div className="col-12  mx-2">
                       <span className="text-500 font-medium"><FormattedMessage id="prodotto.numlotto"/>:</span>
               </div>
               <div className="col-12 mx-2 justify-content-right text-900 font-medium">
                 {this.state.indexLotto>-1?this.state.dati.lista3[this.state.indexLotto].numero:""}
               </div>
               <div className="col-12 justify-content-right mx-2 ">
                       <span className="text-500 font-medium">{this.lingua()=='IT'?this.state.deco1:this.state.deco1EN}:</span>
               </div>
               <div className="col-12 mx-2 justify-content-right text-900 font-medium">
               {this.state.indexLotto>-1?Moment(new Date(this.state.dati.lista3[this.state.indexLotto].data1)).format("DD/MM/yyyy"):""}
               </div>
               <div className="col-12 justify-content-right mx-2 ">
                       <span className="text-500 font-medium">{this.lingua()=='IT'?this.state.deco2:this.state.deco2EN}:</span>
               </div>
               <div className="col-12 mx-2 justify-content-right text-900 font-medium">
               {this.state.indexLotto>-1?Moment(new Date(this.state.dati.lista3[this.state.indexLotto].data2)).format("DD/MM/yyyy"):""}
               </div>
               <div className=" col-12  justify-content-right mx-2">
                       <span className="text-500 font-medium"><FormattedMessage id="prodotto.descrizione"/>:</span>
               </div>
               <div className="col-12  mx-2 justify-content-right text-900 font-medium">

               {this.state.indexLotto>-1?(this.lingua()=='IT'?this.state.dati.lista3[this.state.indexLotto].descrizione:this.state.dati.lista3[this.state.indexLotto].descrizioneen):""}
               </div>
            
               
               </div>
           :
           "")}

      </div>

    </div>
    :""}
    {this.state.tipoVisual>=2?
    <div>
        <div>
        <div class="grid p-3">
        <div className="col-4">
        {(this.state.dati.lista1?<img src={Costanti.UrlCallApi+'file/get/'+this.state.dati.lista1[0].aziendaid+'/prodotto/'+this.state.id+'?'+Math.random()}
         style={{maxWidth:'100%', objectFit: 'contain'}}  />:"")}
        </div>
        <div className="col-8">
        <div className="font-bold text-900 text-4xl mb-3">
      {(this.state.dati.lista1?
        (this.lingua()=='IT'
        ?this.state.dati.lista1[0].nome:this.state.dati.lista1[0].nomeen)
  
      :"")}
      </div>
          <div className="mb-3">
          {(this.state.dati.lista1?
          (this.lingua()=='IT'?this.state.dati.lista1[0].descrizione:this.state.dati.lista1[0].descrizioneen)
            :"")}
         </div>
         {(this.state.dati.conta3>0?
             <div className="grid cardc mx-1 border-round ">
              <div className="col-6">
             <div className="font-bold text-900 text-3xl mx-2 ">
             <FormattedMessage id ="prodotto.lotti" />
             {localStorage.getItem("infolotto")=="S"?
             <label onClick={()=>this.setInfo(true)} style={{cursor:'pointer'}}><i className="pi pi-info-circle mx-2"></i>
                   </label>:<label  />
              }
                <div className="font-bold text-900  mt-3 ">
           
             <FormattedMessage id="prodotto.sellotto" defaultMessage="search">
              {placeholder=>  
                 <Dropdown 
                 value={this.state.selected}
                 options={this.state.dati.lista3} 
                  onChange={(e)=>this.cerca(e.value)} className="w-full"
                     optionLabel="numero" optionValue="id" placeholder={placeholder}/>   
                  }
              </FormattedMessage>  
              </div>
              </div>
              </div>
              <div className="col-6">
              <div className="grid"> 
               <div className="col-6">
                       <span className="text-500 font-medium"><FormattedMessage id="prodotto.numlotto"/>:</span>
               </div>
               
               <div className="col-6 justify-content-right text-900 font-medium">
                 {this.state.indexLotto>-1?this.state.dati.lista3[this.state.indexLotto].numero:""}
               </div>
               <div className="justify-content-right col-6">
                       <span className="text-500 font-medium">{this.lingua()=='IT'?this.state.deco1:this.state.deco1EN}:</span>
               </div>
               <div className="col-6 justify-content-right text-900 font-medium">
               {this.state.indexLotto>-1?Moment(new Date(this.state.dati.lista3[this.state.indexLotto].data1)).format("DD/MM/yyyy"):""}
               </div>
               <div className="justify-content-right col-6">
                       <span className="text-500 font-medium">{this.lingua()=='IT'?this.state.deco2:this.state.deco2EN}:</span>
               </div>
               <div className="col-6 justify-content-right text-900 font-medium">
               {this.state.indexLotto>-1?Moment(new Date(this.state.dati.lista3[this.state.indexLotto].data2)).format("DD/MM/yyyy"):""}
               </div>
               <div className="justify-content-right col-12">
                       <span className="text-500 font-medium"><FormattedMessage id="prodotto.descrizione"/>:</span>
               </div>
               <div className="col-12 justify-content-right text-900 font-medium">

               {this.state.indexLotto>-1?(this.lingua()=='IT'?this.state.dati.lista3[this.state.indexLotto].descrizione:this.state.dati.lista3[this.state.indexLotto].descrizioneen):""}
               </div>
               </div>
               </div>
              </div>
           :
           "")}

        </div>
        </div>
    </div>
    </div>
    :""}

    {/*
    <div className="col-12 md:col-5 lg:col-5 p-3">
       {(this.state.dati.lista1?<img src={Costanti.UrlCallApi+'file/get/'+this.state.dati.lista1[0].aziendaid+'/prodotto/'+this.state.id}
         style={{maxWidth:'100%', objectFit: 'contain'}}  />:"")}
       </div>
       <div className="col-12 md:col-7 lg:col-7 p-3">
       <div className="font-bold text-900 text-4xl mb-3">
      {(this.state.dati.lista1?
        (this.lingua()=='IT'
        ?this.state.dati.lista1[0].nome:this.state.dati.lista1[0].nomeen)
  
      :"")}
      </div>
           <div className="mb-3">
          
            {(this.state.dati.lista1?
            (this.lingua()=='IT'?this.state.dati.lista1[0].descrizione:this.state.dati.lista1[0].descrizioneen)
                
              :"")}
           </div>
           {(this.state.dati.conta3>0?
             <div className="p-2 col-12 md:col-12 lg:col-12">
             <div className="cardc  p-3 border-1 border-50 border-round h-full md:h-full lg:h-full">
             <div className="font-bold text-900 text-3xl mb-3 text-left">
             <FormattedMessage id ="prodotto.lotti" />
         
             {localStorage.getItem("infolotto")=="S"?
             <label onClick={()=>this.setInfo(true)} style={{cursor:'pointer'}}><i className="pi pi-info-circle mx-2"></i>
                   </label>:<label  />
              }
             </div>
        
              
             <FormattedMessage id="prodotto.sellotto" defaultMessage="search">
              {placeholder=>  
                 <Dropdown value={this.state.indexLotto} options={this.state.dati.lista3} 
                  onChange={(e)=>this.cerca(e.value)}
                     optionLabel="numero" optionValue="id" placeholder={placeholder}/>   
                  }
            </FormattedMessage>  
             <div className="justify-content-right col-12">
                       <span className="text-500 font-medium"><FormattedMessage id="prodotto.numlotto"/>:</span>
               </div>
               <div className="col-12 justify-content-right text-900 font-medium">
                 {this.state.dati.lista3[this.state.indexLotto].numero}
               </div>
               <div className="justify-content-right col-12">
                       <span className="text-500 font-medium">{this.lingua()=='IT'?this.state.deco1:this.state.deco1EN}:</span>
               </div>
               <div className="col-12 justify-content-right text-900 font-medium">
               {Moment(new Date(this.state.dati.lista3[this.state.indexLotto].data1)).format("DD/MM/yyyy")}
               </div>
               <div className="justify-content-right col-12">
                       <span className="text-500 font-medium">{this.lingua()=='IT'?this.state.deco2:this.state.deco2EN}:</span>
               </div>
               <div className="col-12 justify-content-right text-900 font-medium">
               {Moment(new Date(this.state.dati.lista3[this.state.indexLotto].data2)).format("DD/MM/yyyy")}
               </div>
               <div className="justify-content-right col-12">
                       <span className="text-500 font-medium"><FormattedMessage id="prodotto.descrizione"/>:</span>
               </div>
               <div className="col-12 justify-content-right text-900 font-medium">

               {this.lingua()=='IT'?this.state.dati.lista3[this.state.indexLotto].descrizione:this.state.dati.lista3[this.state.indexLotto].descrizioneen}
               </div>

             </div>
              </div>
           
           
           :
           
           
           
           "")}
    
      </div>
    
        */}


    </div>
    <div className="grid ml-2 mt-2  text-1000  md:text-xl lg:text-3xl box">
    <FormattedMessage id="prodotto.vai"/>:
    </div>
    <div className="grid ml-2 mt-2 text-1000  md:text-xl lg:text-3xl box">

    {(this.state.dati.conta5>0?
      <a onClick={()=>window.scrollTo({ behavior: 'smooth', top: this.myRef1.current.offsetTop-60 })}>
      <p className="mr-5" style={{color:'blue',cursor:'pointer'}}>
         <FormattedMessage id="prodotto.caratteristiche"/>
          </p>
      </a>:"")} 
    {(this.state.dati.conta6>0?
     <p className="mr-5" style={{color:'blue',cursor:'pointer'}}>
     <a onClick={()=>window.scrollTo({ behavior: 'smooth', top: this.myRef6.current.offsetTop-60 })}>
      <FormattedMessage id="prodotto.materie"/>
      </a></p>:"")}
 
    {(this.state.dati.conta7>0?
     <p className="mr-5" style={{color:'blue',cursor:'pointer'}}>
     <a onClick={()=>window.scrollTo({ behavior: 'smooth', top: this.myRef2.current.offsetTop-60 })}>
      <FormattedMessage id="prodotto.allergeni"/>
      </a></p>:"")}
      {(this.state.dati.conta9>0?
      <p className="mr-5" style={{color:'blue',cursor:'pointer'}}>
      <a onClick={()=>window.scrollTo({ behavior: 'smooth', top: this.myRef3.current.offsetTop-60 })}>
      <FormattedMessage id="prodotto.processi"/>
      </a></p>:"")}
      {(this.state.dati.conta4>0?
    <p className="mr-5"  style={{color:'blue',cursor:'pointer'}}>
    <a onClick={()=>window.scrollTo({ behavior: 'smooth', top: this.myRef4.current.offsetTop-60 })}>
      <FormattedMessage id="prodotto.certificazioni"/>
      </a></p>:"")}
      {(this.state.dati.conta10>0?
    <p className="mr-5"  style={{color:'blue',cursor:'pointer'}}>
    <a onClick={()=>window.scrollTo({ behavior: 'smooth', top: this.myRef5.current.offsetTop-60 })}>
      <FormattedMessage id="prodotto.notarizzazioni"/>
      </a></p>:"")}
    
    </div>


        {(this.state.dati.conta5>0?<div className="ml-2 mt-5 font-bold text-900 text-3xl text-left"><a ref={this.myRef1} style={{color:'#000000'}}>
        <FormattedMessage id="prodotto.caratteristiche"/></a></div>:"")}
        <div className="grid grid-nogutter">
        {(this.state.dati.lista5?this.state.dati.lista5.map((desc, index) => {
         return (
          <div className="p-2 col-12 md:col-6 lg:col-4">
          <div className="cardc p-3 border-1 border-50 border-round h-full md:h-full lg:h-full">
          <div className="justify-content-right col-12">
                    <span className="text-500 font-medium">
                    {this.lingua()=='IT'?desc.nome:desc.nomeen}
                    </span>
            </div>
            <div className="col-12 justify-content-right text-900 font-medium">
            {this.lingua()=='IT'?desc.valore:desc.valoreen}
            </div>
           
          </div>
           </div>
           );
          }):"")}
        </div>

        {(this.state.dati.conta6>0?<div className="ml-2 mt-5 font-bold text-900 text-3xl text-left"><a ref={this.myRef6} style={{color:'#000000'}}>
        <FormattedMessage id="prodotto.materie"/></a></div>:"")}
        <div className="grid grid-nogutter">
        {(this.state.dati.lista6?this.state.dati.lista6.map((desc, index) => {
         return (
          <div className="p-2 col-12 md:col-6 lg:col-4" >
          <div className="cardc  p-3 border-1 border-50 border-round">
          <div className="justify-content-right col-12">
                    <span className="text-500 font-medium">
                     
                      {this.lingua()=='IT'?desc.nome:desc.nomeen}
                      </span>
            </div>
            <div className="col-12 justify-content-right text-900 font-medium">
            {this.lingua()=='IT'?desc.descrizione:desc.descrizioneen}
            </div>
           
          </div>
           </div>
           );
          }):"")}
        </div>

        {(this.state.dati.conta7>0?<div className="ml-2 mt-5 font-bold text-900 text-3xl text-left"><a ref={this.myRef2} style={{color:'#000000'}}>
        <FormattedMessage id="prodotto.allergeni"/></a></div>:"")}
        <div className="grid grid-nogutter">
        {(this.state.dati.lista7?this.state.dati.lista7.map((desc, index) => {
         return (
          <div className="p-2 col-12 md:col-6 lg:col-4" >
          <div className="cardc p-3 border-1 border-50 border-round">
          <div className="justify-content-right col-12">
                    <span className="text-500 font-medium">
                     
                      {this.lingua()=='IT'?desc.nome:desc.nomeen}
                      </span>
            </div>
            <div className="col-12 justify-content-right text-900 font-medium">
            {this.lingua()=='IT'?desc.descrizione:desc.descrizioneen}
            </div>
           
          </div>
           </div>
           );
          }):"")}
        </div>

        {(this.state.dati.conta9>0?
        <div><div className="ml-2 mt-5 font-bold text-900 text-3xl text-left"><a ref={this.myRef3} style={{color:'#000000'}}>
          <FormattedMessage id="prodotto.processi"/></a></div>
      
        <Carousel  useKeyboardArrows  showStatus={false} dynamicHeight={false}>
        {(this.state.dati.lista9?this.state.dati.lista9.map((product, index) => {
         return (     
        <div className="cardc1 ml-2 mt-2 border-1 border-50 border-round h-full md:h-full lg:h-full" style={{ minHeight:'500p'}}>
       
           <div className="mb-3 align-items-center justify-content-center  w-full">
                 <span className="bg-blue-500 ml-2 mt-2 text-0 flex align-items-center justify-content-center border-circle" style={{ width: '2rem', height: '2rem' }}>
                       {index+1}
                  </span>
             </div>
          
 
    <div className="d-flex align-items-center" style={{ marginTop: (product.hasImageProcesso?'0%':'15vh'),marginBottom: (product.hasImageProcesso?'0%':'15vh')}}>
    
           <div className="justify-content-right  cardc2 "  >
            {(product.hasImage?
                    (product.hasImage.startsWith("video")?
                    <div>
                    <video  class="video-background"  width="100" height="100" controls autoPlay muted={true} playsinline>
                    <source src={Costanti.BaseHttp+'img/produzione_'+product.id+'?'+Math.random()}  alt="" 
                    type= {product.hasImage} />
                    </video>
                    </div>
                    :<img className="immagine slider77 mb-3 align-items-center justify-content-center  w-full" src={Costanti.UrlCallApi+'file/get/'+product.aziendaid+'/produzione/'+product.id+'?'+Math.random()} alt="" 
                    style={{ objectFit: 'contain', maxHeight:'25vh'}}/>)
                    :(product.hasImageProcesso?
                    (product.hasImageProcesso.startsWith("video")?
                    <div>
                    <video  class="video-background"  playsinline style={{ objectFit: 'contain', maxHeight:'25vh'}} controls autoPlay muted={true}>
                    <source src={Costanti.BaseHttp+'img/processo_'+product.processoid+'?'+Math.random()} alt="" 
                    type= {product.hasImageProcesso} style={{ objectFit: 'contain', maxHeight:'25vh'}}/>
                    </video>
                    </div>
                    :
                    <img className="immagine slider77 mb-3 align-items-center justify-content-center  w-full" src={Costanti.UrlCallApi+'file/get/'+product.aziendaid+'/processo/'+product.processoid} alt="" 
                    style={{ objectFit: 'contain', maxHeight:'25vh'}}/>
                    ):<div></div>))}
                <br/>{this.lingua()=='IT'?product.descProcesso:product.descProcessoen} 
           </div>
           <div className="justify-content-right  cardc1 "  >
           {this.lunghezza(this.lingua()=='IT'?product.descrizione:product.descrizioneen)>1500?
           <div>
              {this.splitta1(this.lingua()=='IT'?product.descrizione:product.descrizioneen,1500)}
         
            <Fieldset class="cardc1" toggleable collapsed={true} style={{border:'0'}}>
             {this.splitta2(this.lingua()=='IT'?product.descrizione:product.descrizioneen,1500)}
            </Fieldset>
            </div>:
                  <p>
                  {this.lingua()=='IT'?product.descrizione:product.descrizioneen}
                  </p>
            
            }
            </div>
            </div>
         
    
             <div className="justify-content-right" style={{marginBottom:'5vh',marginTop:'15px',position:'static',bottom:'0'}}>
              <b><FormattedMessage id="azienda.stabilimento"/>:</b> &nbsp; {product.descStabilimento}
        
           
              
              <div onClick={()=>{this.mappa=product.indirizzoStabilimento;
                            this.setVisible1(true)}} style={{cursor:'pointer'}}>
                              <b> <FormattedMessage id="azienda.indirizzo"/>:</b> 
                              <i className="pi pi-map-marker mx-2"></i>
                            {(this.state.dati.lista2?this.state.dati.lista2[0].sede:"")}
                            </div>
             
              </div>
        </div>
   );
  }):"")}
        </Carousel>
        </div>:"")}
       


      
           {(this.state.dati.conta4>0?<div className="ml-2 mt-5 font-bold text-900 text-3xl text-left"><a ref={this.myRef4} style={{color:'#000000'}}>
           <FormattedMessage id="prodotto.certificazioni"/></a></div>:"")}
      
        {(this.state.dati.conta4>0?
        <div className="card cardc4 ml-2 mt-2" >  
        <DataTable value={this.state.dati.lista4}
     rows={this.state.pageSize} totalRecords={this.state.dati.conta4}
     paginator={false} 
     responsive={true} 
     breakpoint="300px"
           responsiveLayout="stack">
         <Column id="id1" header={this.lingua()=='IT'?"Nome":"Name"}
         
         body={(item) => (
          <div className="box">
        {this.lingua()=='IT'?item.nome:item.nomeen}
          </div>
      )} />
         <Column id="id3"
          body={(item) => (
            <a href={Costanti.UrlCallApi+'file/get/'+item.aziendaid+'/certificato'+(this.lingua()=='IT'?"":"en")+'/'+item.id} target="_blank">
               <img style={{maxWidth:'90px',maxHeight:'90px'}} src={Costanti.UrlCallApi+'file/preview/'+item.aziendaid+'/certificato'+(this.lingua()=='IT'?"":"en")+'/'+item.id+'?'+Math.random()}/>
            </a>
        )}/>
         <Column id="id4"
          body={(item) => (
            <Button className="p-button-info" visible={item.hasImage} alt={item.hasImage?"Download":"Not avaible"}>
            <a href={Costanti.UrlCallApi+'file/get/'+item.aziendaid+'/certificato'+(this.lingua()=='IT'?"":"en")+'/'+item.id} target="_blank">
                  <i className="pi pi-download text-white" tooltip="Scarica"></i>
            </a>
            </Button>
        )}/>
       
         
     </DataTable></div>:"")}


     {(this.state.dati.conta10>0?<div className="ml-2 mt-5 font-bold text-900 text-3xl text-left"><a ref={this.myRef5} style={{color:'#000000'}}>
     <FormattedMessage id="prodotto.notarizzazioni"/></a></div>:"")}
         
     {(this.state.dati.conta10>0?
          <div className="card cardc4 ml-2 mt-2 " >  
        <DataTable value={this.state.dati.lista10} 
     rows={this.state.pageSize} totalRecords={this.state.dati.conta4}
     paginator={false} 
     responsive={true}  
     breakpoint="350px" autoLayout={true}
           responsiveLayout="stack">
         <Column id="id1" header="Hash" headerClassName="cardc2"   
           body={(item) => (
            <div className="box">
             {this.split4(item.hash)}
            </div>
        )}
         />
         
         <Column id="id3"  header={this.lingua()=='IT'?"Data":"Date"} 
                     body={(item) => (
                      <span className="lg:font-medium">{Moment(new Date(item.datains)).format("DD/MM/yyyy HH:mm:ss")}</span>
                  )}/>
         <Column id="id4" header=""
          body={(item) => (
            <div>
            <Button className="p-button-info lg:mx-1 lg:mt-1 mr-1"  tooltip="Download">
               <a href={Costanti.UrlCallApi+'file/getHash/'+item.hash} target="_blank">
                  <i className="pi pi-download lg:mr-2 text-white"></i>
                  {this.state.tipoVisual>1?<span className="font-small text-white text-sm">{this.lingua()=='IT'?"Scarica":"Download"} </span>:""}
            </a>
            </Button>
            
            <Button className="p-button-warning" tooltip={this.lingua()=='IT'?"Visualizza":"View"}  >
            <a href={'https://algoexplorer.io/tx/'+item.transazione} target="_blank">
                  <i className="pi pi-search lg:mr-2 text-white"></i>
                  {this.state.tipoVisual>1?<span className="font-small text-white text-sm">{this.lingua()=='IT'?"Visualizza":"View"} </span>:""}
            </a>
            </Button>
            </div>
        )}/>
         
     </DataTable></div>:"")}


      

        

             
           

<div className="border-1 border-50 border-round  grid grid-nogutter">
<div className="col-12 md:col-12 lg:col-12 p-3">
<div className="flex justify-content-between text-1000">
                    <span className=" text-4xl"><FormattedMessage id="prodotto.azienda"/></span>
                    <span className="inline-flex">
                        
                        <Link to={"/"+(this.state.dati.lista2?this.state.dati.lista2[0].sigla:"")+"/schedaazi/"+(this.state.dati.lista2?this.state.dati.lista2[0].id:"")}>
                        <span className="font-small">
                        <FormattedMessage id="prodotto.dettagli"/></span></Link>
                    </span>
</div>
</div>

<div class="grid p-3">
                 <div className="col-4">
                 <div className="card  flex align-items-center justify-content-center">
                  {(this.state.dati.lista2?
                 <img src={Costanti.UrlCallApi+'file/get/'+this.state.dati.lista2[0].id+'/logo/'+this.state.dati.lista2[0].id+'?'+Math.random()}  
                 style={{top:'60%', left:'60%', maxWidth:'100%', maxHeight:'100%', objectFit: 'contain'}}  />:"")}
                 </div>
                 </div>
                 <div class="col-8">
                     <div className="azie1 text-3xl">
                       {(this.state.dati.lista2?this.state.dati.lista2[0].ragionesociale:"")}
                    </div>
                </div>
                <div class="grid p-3">
                        <div className="col-12  p-3"> 
                            <div onClick={()=>{this.mappa=(this.state.dati.lista2?this.state.dati.lista2[0].sede:"-");
                            this.setVisible1(true)}} style={{cursor:'pointer'}}>
                              <i className="pi pi-map-marker mr-2"></i>
                            {(this.state.dati.lista2?this.state.dati.lista2[0].sede:"")}
                            </div>
                            </div>
                        

                        <div className={this.state.tipoVisual==1?"col-12  p-3":"col-6  p-3"}> 
                        <i className="pi pi-envelope mr-2"></i> {(this.state.dati.lista2?this.state.dati.lista2[0].email:"")}
                        </div>
                        <div className={this.state.tipoVisual==1?"col-12  p-3":"col-6  p-3"}> 
                            <i className="pi pi-phone mr-2"></i> {(this.state.dati.lista2?this.state.dati.lista2[0].telefono:"")}
                        </div>
                      
                 </div>
                 <div class="grid p-3">

                 </div>
              
             </div>



        </div>

        </div>

        </div>
      )  
    }
    }

    export default Scheda;